import { v4 as uuid } from 'uuid';

const GENERATED_DEVICE_ID_KEY = 'GENERATED_DEVICE_ID';

export const getDeviceAdId = () => {
  let deviceId = localStorage.getItem(GENERATED_DEVICE_ID_KEY);
  if (!deviceId) {
    deviceId = uuid();
    localStorage.setItem(GENERATED_DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
};
